import { Button } from "@appretio/ui-kit";
import { useNavigate } from "react-router-dom";
import {
  copyrightText,
  errorCode,
  forbiddenCard,
  forbiddenContentContainer,
  forbiddenMainContent,
  forbiddenMessage,
  forbiddenPageBase,
  forbiddenTitle
} from "./ForbiddenPage.css";

export function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className={forbiddenPageBase}>
      <div className={forbiddenMainContent}>
        <div className={forbiddenContentContainer}>
          <div className={forbiddenCard}>
            <p className={errorCode}>403</p>
            <h1 className={forbiddenTitle}>Insufficient permissions</h1>
            <p className={forbiddenMessage}>
              You do not have access to this page.
              <br />
              Contact your administrator if you believe this is a mistake.
            </p>
            <Button variant="primary" onClick={() => navigate("/")}>
              Go to Home
            </Button>
          </div>
        </div>
      </div>
      <p className={copyrightText}>© Appretio {new Date().getFullYear()}</p>
    </div>
  );
}
